var _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandComingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.502,
    transform: "translate(41 12)",
    fill: "#A6A6A6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.715 2.477A3.716 3.716 0 0 0 0 6.192v27.245a3.716 3.716 0 0 0 3.715 3.715h32.199a3.716 3.716 0 0 0 3.715-3.715V6.192a3.716 3.716 0 0 0-3.715-3.715H3.715zm0 2.477h8.205c.255 0 .464.209.464.464v1.548a.466.466 0 0 1-.464.464H2.94a.466.466 0 0 1-.464-.464v-.774c0-.681.557-1.238 1.238-1.238zm32.973 7.43H2.94a.466.466 0 0 1-.464-.464V9.133c0-.255.209-.464.464-.464h10.681l2.338-3.506a.461.461 0 0 1 .387-.21h19.567c.68 0 1.238.558 1.238 1.239v5.728a.466.466 0 0 1-.464.464zM19.814 32.818c-5.123 0-9.288-4.165-9.288-9.288 0-5.124 4.165-9.288 9.288-9.288 5.124 0 9.288 4.164 9.288 9.288 0 5.123-4.164 9.288-9.288 9.288zm0-16.1c-3.753 0-6.81 3.058-6.81 6.812 0 3.753 3.057 6.81 6.81 6.81 3.754 0 6.812-3.056 6.812-6.81 0-3.754-3.058-6.812-6.812-6.812zm-3.715 8.05a1.242 1.242 0 0 1-1.238-1.238 4.958 4.958 0 0 1 4.953-4.954c.682 0 1.239.557 1.239 1.238 0 .682-.557 1.239-1.239 1.239a2.484 2.484 0 0 0-2.476 2.477c0 .68-.558 1.238-1.239 1.238z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontFamily: "NouvelR",
    fontSize: 18,
    fontWeight: 500,
    letterSpacing: -0.12,
    fill: "#000",
    fillOpacity: 0.45
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 30.248,
    y: 75
  }, "Picture"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "NouvelR",
    fontSize: 12,
    fill: "#000",
    fillOpacity: 0.25
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 23.048,
    y: 90
  }, "Coming soon"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandComingSoon);
export default __webpack_public_path__ + "static/media/brand_coming_soon.440c180909baf270ad883016dae5ade9.svg";
export { ForwardRef as ReactComponent };